export const mediaItems = [
  {
    type: "youtube",
    src: "https://youtu.be/Qpvh8DmcQcY?si=VcDTz5ynShqBDyMU",
  },
  {
    type: "youtube",
    src: "https://youtu.be/rWo-V1rJRgA?si=ABAX2pXbnaTdI139"
  },
  {
    type: "youtube",
    src: "https://youtu.be/eARn01pojQA?si=BYMXtRXYcAfWKJ7R",
  },
  {
    type: "youtube",
    src: "https://youtu.be/disoYQHZsLk?si=hG_ykkFa1omOECqd",
  },
  {
    type: "youtube",
    src: "https://youtu.be/3x_Fecy0yQM?si=EPxORYG0I7YTEzOd",
  },
  {
    type: "youtube",
    src: "https://youtu.be/G3m5AZNqvpg?si=Q7MVgHDHUCVl3rHc",
  },
  {
    type: "youtube",
    src: "https://youtu.be/6P1IXuRu2jE?si=Ajh3R0ypFn3hnIT2",
  },
  {
    type: "youtube",
    src: "https://youtu.be/rSMFnTWpTD8?si=MdD6n-5-oyYLDzGy",
  },
  {
    type: "youtube",
    src: "https://youtu.be/fRGmed6V7as?si=CdTHrakcxm22H1G9",
  },

  
]